import React from "react";
import { Typography } from "@material-ui/core";
import InvoiceList from "../components/InvoiceList";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 190px)", // padding: 30px * 2, title: 80px + 50px, total 190px
    margin: theme.spacing(2, 0),
  },
}));
const BillingSettings = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4" gutterBottom>
        Billing
      </Typography>
      <InvoiceList />
    </div>
  );
};

export default BillingSettings;
